import _ from "lodash"

// A rate category name is free text, and a ratesheet stores it twice: as a key
// of each rates hash and as a value in category_order/categories. The API key
// transforms leave a ratesheet's rates keys verbatim (app/javascript/utils.tsx),
// so the two spellings stay in step provided the name is canonical when it is
// created. Ruby folds case on read for names created before that was true:
// domain/pricing/lib/pricing/values/category_name.rb.
export const CANONICAL = /^[a-z0-9_]+$/

export const normalizeCategoryName = (category: string): string =>
  _.trim(category || "").toLowerCase()

export const categoryNameError = (category: string, existing: string[]): string | null => {
  const name = normalizeCategoryName(category)

  if (name === "") {
    return "Rate category cannot be blank"
  }

  if (_.includes(_.map(existing, normalizeCategoryName), name)) {
    return "Rate category has already been defined"
  }

  if (!CANONICAL.test(name)) {
    return "Rate category may only contain lowercase letters, digits and underscores"
  }

  if (!/[a-z0-9]/.test(name)) {
    return "Rate category must contain a letter or digit"
  }

  return null
}
